import { Core } from "Components/core";
import Swiper, { Navigation, Pagination, Lazy } from "swiper";
import { _createForOfIteratorHelper } from "./helpers";
// import { Breakpoints } from "Components/breakpoints";

export class Carousel extends Core {
  constructor(domElem) {
    super(domElem, Carousel.className);

    this.elemClassName = Carousel.className + Core.ELEM_DELIM;

    this._activeIndex = -1;
    this._items = this.getElemsNode("item");
    this._inner = this.getElemNode("inner");
    this._container = this.getElemNode("container");
    // const mq = this.params.mq;

    // if (mq) {
    //   console.log("mq", mq);
    //   Breakpoints.getMatches()[mq] && _this._initSwiper();
    //   Breakpoints.domElem.addEventListener(
    //     "mediaChange",
    //     debounce(
    //       _this._onMediaChange.bind(assertThisInitialized_default()(_this)),
    //       200
    //     )
    //   );
    // } else {
    this._initSwiper();
    // }
  }

  getActiveIndex() {
    return this._swiper.activeIndex;
  }

  update() {
    this._swiper.update();
  }

  getLibInstance() {
    return this._swiper;
  }

  _cropText() {
    var cropText = document.getElementsByClassName("crop_text");

    var _iterator = _createForOfIteratorHelper(cropText),
      _step;

    try {
      var _loop = function _loop() {
        var cropTextElement = _step.value;
        cropTextElement.nextSibling.style = "pointer-events:none";
        cropTextElement.classList.add("crop");
        cropTextElement.nextSibling.classList.remove("crop-button_opened");
        cropTextElement.nextSibling.innerHTML = "Читать полностью";
        setTimeout(function () {
          cropTextElement.nextSibling.style = "";
        }, 350);
        setTimeout(function () {
          cropTextElement.classList.add("text_crop-3");
        }, 350);
      };

      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  _getOptions() {
    var options = this.params.options;
    options.pagination &&
      (options.pagination = this._getPaginationOptions(options.pagination));
    options.navigation && (options.navigation = this._getNavigationOptions());
    options.modules = [Navigation, Pagination, Lazy];
    if (this.hasMod("has-thumbs")) {
      var thumbs = new Carousel(this.domElem.querySelector(".carousel-thumbs"));
      thumbs &&
        (options.thumbs = {
          swiper: thumbs.getLibInstance(),
        });
    }
    return options;
  }

  _getPaginationOptions(type) {
    if (type === "bollets") {
      return {
        el: this.domElem.querySelector(
          ".".concat(this.elemClassName, "dot-group")
        ),
        type: "bollets",
        bulletClass: "".concat(this.elemClassName, "dot"),
        bulletActiveClass: "".concat(this.elemClassName, "dot_active"),
        modifierClass: "".concat(this.elemClassName, "dot_"),
        currentClass: "".concat(this.elemClassName, "dot_current"),
        totalClass: "".concat(this.elemClassName, "dot_total"),
        hiddenClass: "".concat(this.elemClassName, "dot_hidden"),
        clickable: true,
      };
    } else if (type === "fraction") {
      return {
        type: "fraction",
        el: this.domElem.querySelector(
          ".".concat(this.elemClassName, "pagination-counetr")
        ),
        currentClass: "".concat(this.elemClassName, "counetr_current"),
        totalClass: "".concat(this.elemClassName, "counetr_total"),
      };
    }
  }

  _getNavigationOptions() {
    var domElem = this.domElem;
    return {
      nextEl: domElem.querySelector(
        ".".concat(this.elemClassName, "arrow_dir_next")
      ),
      prevEl: domElem.querySelector(
        ".".concat(this.elemClassName, "arrow_dir_prev")
      ),
      disabledClass: "".concat(this.elemClassName, "arrow_disabled"),
      hiddenClass: "".concat(this.elemClassName, "arrow_hidden"),
    };
  }

  _onMediaChange(e) {
    var libInited = this.hasMod("lib", "inited");
    e.detail.matches[this.params.mq]
      ? libInited || this._initSwiper()
      : libInited && this._destroySwiper();
  }

  _initSwiper() {
    this._toggleSwiperClasses(true);

    var swiper = (this._swiper = new Swiper(
      this._container ? this._container : this.domElem,
      Object.assign(this._getOptions(), {
        init: false,
        on: {
          init: this._onInit.bind(this),
          destroy: this._onDestroy.bind(this),
        },
      })
    ));
    swiper.init();
  }

  _destroySwiper(deleteInstance, cleanStyles) {
    this._swiper.destroy(
      typeof deleteInstance === "undefined" ? true : deleteInstance,
      typeof cleanStyles === "undefined" ? true : cleanStyles
    );
  }

  _onInit() {
    this._swiper.on(
      "slideChangeTransitionStart",
      this._onBeforeChange.bind(this)
    );

    this._swiper.on("slideChangeTransitionEnd", this._onChange.bind(this));

    this._swiper.on("touchStart", this._onTouchStart.bind(this));

    this._swiper.on("touchMove", this._onTouchMove.bind(this));

    this._swiper.on("touchEnd", this._onTouchEnd.bind(this));

    this.setMod("lib", "inited");
  }

  _toggleSwiperClasses(mode) {
    var method = mode ? "add" : "remove",
      container = this._container;
    (container ? container : this.domElem).classList[method](
      "swiper-container"
    );
    this.setMod("non-interacting", mode);

    this._inner.classList[method]("swiper-wrapper");

    this._items.forEach(function (item) {
      return item.classList[method]("swiper-slide");
    });
  }
  _onDestroy() {
    this._toggleSwiperClasses(false);

    this.delMod("lib", "inited");
  }
  _onBeforeChange() {
    this.delMod("non-interacting");
  }
  _onChange() {
    // console.log('-общее кол-во: ',  this._items.length);
    // console.log('-активный: ', this.getActiveIndex());
    this._cropText();
  }
  _onTouchStart() {}
  _onTouchMove() {}
  _onTouchEnd() {}

  static className = "carousel";
  static instances = {};

  static init(selector = `.${Carousel.className}`) {
    document.querySelectorAll(selector).forEach((el) => new Carousel(el));
  }
}
